import React, { useEffect, useState } from 'react';
import TreeItem from '@material-ui/lab/TreeItem';
import LensIcon from '@material-ui/icons/Lens';
import { getFormById, getFormByIdWithGql, getFormByIdWithoutAuthen } from '@/service/formManagementService';
import { getTicketDetailAPI } from '@/service/ticketService';
import {  API, I18n } from 'aws-amplify';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import { Skeleton } from '@material-ui/lab';
import { Tooltip } from '@material-ui/core';

export default function DrilldownTreeItem({ itemChild, argsCommon, item, selectDrilldown, key }) {
    const [itemLabel , setItemLabel] = useState(itemChild?.label);
    const [loading , setLoading] = useState(false);
    console.log('item :>>----------------- ', item);
    useEffect(() => {
        if(!itemLabel) {
            const tagItemType = Utils.getPrefixOfId(itemChild.id);
            setLoading(true);
            console.log('tagItemType', tagItemType)
            if (tagItemType === 'tag') {
                getFormByIdWithoutAuthen(API, itemChild.id).then((fieldDetail) => {
                    let fieldName = Utils.convertJSONDataToObject(fieldDetail?.name);
                    setLoading(false);
                    setItemLabel(fieldName?.jp?.text);
                    
                })
            } else {
                getTicketDetailAPI(API, itemChild.id).then((ticketDetailResult) => {
                    let detailTicket = ticketDetailResult.detailTicket;
                    let titketTitle =  Utils.getTitle(detailTicket?.settingTitle);
                    setLoading(false);
                    setItemLabel(titketTitle);
                    
                })
            }
        }
    }, [itemChild]);

    if (loading) {
       
        return (
            <TreeItem
                className={`itemIcon ${{...item}.usage === Constant.FORM_USAGE.TAG ? 'childTagItem' : 'childItem'}`}
                nodeId={itemChild.id}
                // onLoad={true}
                label={'...'}
                
                // disableselection="true"
                onClick={e => selectDrilldown(argsCommon, item, itemChild)}
                icon={<LensIcon  fontSize="small" />}
                key={key}
            />
        )
    }

    return (
        <Tooltip title={`${itemLabel} ${itemChild.total ? `(${itemChild.total})` : ''}`} arrow= {false} placement = "top-start">
        <TreeItem
            className={`itemIcon ${{...item}.usage === Constant.FORM_USAGE.TAG ? 'childTagItem' : 'childItem'}`}
            nodeId={itemChild.id}
            label={`${itemLabel} ${itemChild.total ? `(${itemChild.total})` : ''}`}
            disableselection="true"
            onClick={e => selectDrilldown(argsCommon, item, itemChild)}
            icon={<LensIcon fontSize="small" />}
            key={key}
        />
        </Tooltip>
    );
}
